function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { useCallback, useMemo } from 'react';
import useSWR, { unstable_serialize, useSWRConfig } from 'swr';
import { fetchWithToken } from '@adsk/acs-sc-web-platform-api';
import { ALLOY_KEY_PREFIX, baseParser, setDataInStorage } from './commonCache';
let swrCache;
export const clearNetworkCache = () => {
  if (swrCache instanceof Map) {
    swrCache.clear();
  }
  Object.keys(sessionStorage).filter(k => k.startsWith(ALLOY_KEY_PREFIX)).forEach(k => sessionStorage.removeItem(k));
};

// eslint-disable-next-line @typescript-eslint/no-explicit-any

const defaultConfig = {
  fetcher: fetchWithToken,
  revalidateOnFocus: false,
  shouldRetryOnError: false,
  revalidateOnMount: true,
  onSuccess: setDataInStorage
};
const alloyPrefix = str => "".concat(ALLOY_KEY_PREFIX).concat(str);
export const useSWRAlloy = function (key) {
  let fn = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : fetchWithToken;
  let config = arguments.length > 2 ? arguments[2] : undefined;
  const {
    cache
  } = useSWRConfig();
  swrCache = cache;
  const cacheKey = unstable_serialize(key);
  const fallbackData = useMemo(() => baseParser(sessionStorage.getItem(alloyPrefix(cacheKey))), [cacheKey]);
  const finalConfig = useMemo(() => _objectSpread(_objectSpread({
    fallbackData
  }, defaultConfig), config), [config, fallbackData]);
  const res = useSWR(key, fn, finalConfig);
  const originalMutate = res.mutate;

  // This mutate wrapper saves the data to local storage.
  // We need it because `onSuccess` isn't called when calling mutate with shouldRevalidate=false
  const mutateWrapper = useCallback((data, opts) => {
    const shouldUpdateCache = opts === false;
    const mutateRes = originalMutate(data, opts);
    if (data && shouldUpdateCache) {
      setDataInStorage(data, cacheKey);
    }
    return mutateRes;
  }, [cacheKey, originalMutate]);
  const revalidate = useCallback(() => originalMutate(), [originalMutate]);
  const clearSessionStorage = () => {
    sessionStorage.removeItem("".concat(ALLOY_KEY_PREFIX).concat(key));
  };
  return _objectSpread(_objectSpread({}, res), {}, {
    mutate: mutateWrapper,
    revalidate,
    clearSessionStorage
  });
};
//# sourceMappingURL=cache.js.map